<app-custom-table
  titleSingleResult="Seminar"
  titleMultipleResults="Seminare"
  class="w-full"
  noDataIcon="fa-calendar-heart"
  noDataMessage="Du hast derzeit keine Seminare verfügbar."
  noSearchResultsIcon="fa-calendar-heart"
  noSearchResultsMessage="Es gibt keine Kurse, die mit deinen Suchkriterien übereinstimmen."
  [columns]="columns"
  [dataSource$]="dataSource$"
  [isLoading]="isLoading"
  [filters]="filters" />
